<template>
  <div class="w-full rounded-2xl overflow-hidden shadow-lg">
    <button
      @click="onDropdownClick"
      class="w-full bg-[#40A9FF] py-3 px-5 font-bold flex justify-between items-center"
    >
      <span>No transition word or phrase found</span>
      <Icon
        :icon="isOpen ? 'ant-design:up-outlined' : 'ant-design:down-outlined'"
        class="text-xl"
      />
    </button>

    <div v-if="isOpen" class="w-full bg-white">
      <div class="w-full p-5">
        <span class="" v-if="!newItem"
          >Insert a transition word or phrase into the highlighted sentence.</span
        >

        <div class="w-full flex items-center flex-col space-y-3" v-if="newItem">
          <div
            class="w-full p-3 flex justify-between items-center rounded-lg border-2 border-primary-main outline outline-2 outline-primary-main/20"
          >
            <span class="">{{ selectedOption || '' }}</span>

            <Icon :icon="'ant-design:down-outlined'" class="text-lg text-gray-400" />
          </div>

          <div class="w-full shadow-lg rounded-lg overflow-y-auto max-h-[250px] overflow-hidden">
            <template v-if="!selectedOption">
              <div
                v-for="(option, index) in suggestions"
                :key="index"
                class="w-full bg-white hover:!bg-gray-200 py-3 px-4 cursor-pointer duration-200"
                :class="selectedOption === option.title ? '!bg-gray-300' : ''"
                @click="() => onOptionClick(option.title)"
              >
                <span class="">{{ option.title }}</span>
              </div>
            </template>

            <template v-if="selectedOption">
              <div
                v-for="(submenu, index) in activeSubmenu"
                :key="index"
                class="w-full flex justify-start items-center hover:!bg-gray-200 py-3 px-4 cursor-pointer duration-200"
                @click="insertSentence(submenu)"
              >
                <div class="w-1 h-1 rounded-full bg-black mr-2"></div>
                <span>{{ submenu }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="w-full flex border-t border-t-gray-300">
        <button
          v-if="!newItem"
          @click="onAddItemClick"
          class="hover:!text-primary-main text-center flex flex-col flex-1 items-center p-3 border-r border-solid border-gray-300"
        >
          <Icon icon="ant-design:plus-circle-outlined" class="text-3xl mb-1" />
          <span class="text-xs">Add Transition</span>
        </button>

        <button
          v-if="newItem"
          @click="onRemoveItemClick"
          class="hover:!text-primary-main text-center flex flex-col flex-1 items-center p-3"
        >
          <Icon icon="ant-design:arrow-left-outlined" class="text-3xl mb-1" />
          <span class="text-xs">Go Back</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Icon } from '@iconify/vue';
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({
  components: {
    Icon
  }
})
export default class TransitionDropdown extends Vue {
  @Prop()
  public isOpen!: boolean;

  @Prop()
  public suggestions: any;

  public selectedOption: string | null = null;
  public selectedTransition: string | null = null;
  public newItem = false;

  public onSelectedTransitionChange(val: any) {
    if (val === this.selectedTransition) this.selectedTransition = null;
    else this.selectedTransition = val;
  }

  get activeSubmenu() {
    return this.suggestions?.find((option: any) => option.title === this.selectedOption)?.submenus || [];
  }

  public onDropdownClick() {
    this.$emit('toggleDropdown');
    this.$emit('card-click');
  }
  public onAddItemClick() {
    this.newItem = true;
  }
  public onRemoveItemClick() {
    this.selectedOption = null;
    this.newItem = false;
  }
  public onOptionClick(option: string) {
    this.selectedOption = option;
  }
  public insertSentence(sentence: string) {
    this.$emit('insertSentence', sentence);
  }
}
</script>
